import C_Local from "../const/C_Local";

/**
 * Provides methods for working with sound and music.
 */
class SoundController
{


    constructor()
    {
        this.app = PIXI.app;
        this.soundBlobs = [];

        this.musicFadeTimeMs = 1000;
        this.musicFadeTimeSec = this.musicFadeTimeMs/1000;

        this.soundEnabled = this.app.localData.getBooleanValue(C_Local.SOUND_ENABLED);
        this.musicEnabled = this.app.localData.getBooleanValue(C_Local.MUSIC_ENABLED);

        this.MAX_MUSIC_VOLUME = 0.3;
    }


    /**
     * Toggle sound state.
     * @public
     */
    toggleSound()
    {
        this.soundEnabled = !this.soundEnabled;
        this.app.localData.saveValue(C_Local.SOUND_ENABLED, this.soundEnabled);
    }


    /**
     * Toggle music state.
     * @public
     */
    toggleMusic()
    {
        this.musicEnabled = !this.musicEnabled;
        this.app.localData.saveValue(C_Local.MUSIC_ENABLED, this.musicEnabled);
        if (this.music)
        {
            if (this.musicEnabled)
            {
                this.music.fade(0, this.MAX_MUSIC_VOLUME, this.musicFadeTimeMs);
            }
            else
            {
                this.music.fade(this.MAX_MUSIC_VOLUME, 0, this.musicFadeTimeMs);
            }
        }
    }


    /**
     * Getter method for the sound state
     * @public
     * @returns {Boolean} Is the sound enabled ?
     */
    getSoundEnabled()
    {
        return this.soundEnabled;
    }


    /**
     * Getter method for the music state
     * @public
     * @returns {Boolean} Is the music enabled ?
     */
    getMusicEnabled()
    {
        return this.musicEnabled;
    }


    /**
     * Play sound with a specified id
     * @param {String} sndId
     */
    playSound(sndId, volume=1)
    {
        let snd = this.getSound(sndId, false, volume);
        if (this.soundEnabled)
        {
            snd.play();
        }
    }


    getSound(sndId, loop=false, volume=1)
    {
        let blobUrl = this.soundBlobs[sndId];
        if (blobUrl == undefined)
        {
            let byteArray = PIXI.loader.resources[sndId + '.mp3'];
            if (byteArray)
            {
                let blob = new Blob([byteArray.data], {type:"audio/mpeg"});
                blobUrl = window.URL.createObjectURL(blob);
                this.soundBlobs[sndId] = blobUrl;
            }
            else
            {
                console.log("Could not find data for sound with id : " + sndId);
            }
        }

        let snd = new Howl({src:[blobUrl], format:["mp3"], loop:loop, volume:volume});

        return snd;
    }


    playMusic(musicId)
    {
        if (this.music)
        {
            this.stopMusic();
            TweenMax.delayedCall(this.musicFadeTimeSec, this.startMusic, [musicId], this);
        }
        else
        {
            this.startMusic(musicId);
        }

    }


    stopMusic()
    {
        if (this.music)
        {
            this.music.fade(this.music._volume, 0, this.musicFadeTimeMs);
            TweenMax.delayedCall(this.musicFadeTimeSec, this.music.stop, [], this.music);
        }
    }


    startMusic(musicId)
    {
        this.music = this.getSound(musicId, true, 0);
        this.music.play();
        if (this.musicEnabled)
        {
            console.log('music fade');
            this.music.fade(0, this.MAX_MUSIC_VOLUME, this.musicFadeTimeMs);
        }
    }


}


export default SoundController;